export const APP_NAME = 'AutofinPlan';
export const APP_DESCRIPTION = 'A fantastic SaaS to make your life easier.';
